function Title({ children }: React.PropsWithChildren) {
    return <div className="title px-3">{children}</div>;
}

export default Title;
